<ng2-pdfjs-viewer #pdfViewer [fullScreen]="true"></ng2-pdfjs-viewer>
